import type { PlanDto, PlatformUsage, TenantUsage } from '@order-pilot/shared';
import { api } from '@/lib/api';

/** Fields an SA may PATCH on a plan. Null lifts a ceiling; undefined leaves it. */
export interface UpdatePlanInput {
  maxBillsPerDay?: number | null;
  maxBranches?: number | null;
  maxDevices?: number | null;
  pricePerMonth?: string | null;
  currency?: string;
  aiCreditsPerMonth?: number;
}

export const planKeys = {
  all: ['plans'] as const,
  list: () => ['plans', 'list'] as const,
};

export const usageKeys = {
  all: ['usage'] as const,
  platform: () => ['usage', 'platform'] as const,
  tenant: (id: string) => ['usage', 'tenant', id] as const,
};

export function fetchPlans(signal?: AbortSignal): Promise<PlanDto[]> {
  return api.get<PlanDto[]>('/admin/plans', { signal });
}

export function updatePlan(
  id: string,
  input: UpdatePlanInput,
): Promise<PlanDto> {
  return api.patch<PlanDto>(`/admin/plans/${id}`, input);
}

export function fetchPlatformUsage(signal?: AbortSignal): Promise<PlatformUsage> {
  return api.get<PlatformUsage>('/admin/usage', { signal });
}

export function fetchTenantUsage(
  id: string,
  signal?: AbortSignal,
): Promise<TenantUsage> {
  return api.get<TenantUsage>(`/admin/tenants/${id}/usage`, { signal });
}
